import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Route-agnostic, prop-driven application shell.
 *
 * The package's AppShell knows nothing about the SPA's data model — it only
 * owns the structural concerns: sidebar/topbar layout, collapse persistence,
 * and the mounting points for overlays (command palette, shortcuts panel).
 *
 * Everything app-specific (workspace name, dark-native gating, shortcut
 * registration, palette + shortcuts overlay contents, sidebar slots) is
 * passed in by the consumer. The SPA wires this via `AppShellSpa`.
 */
import { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
const COLLAPSE_KEY = 'pipebase:shell:collapsed';
export function AppShell({ navGroups, brandMark, rightSlot, commandPalette, shortcutsPanel, onOpenPalette, crumbs, darkNative = true, bare = false, sidebar, children, }) {
    const [collapsed, setCollapsed] = useState(() => {
        return typeof localStorage !== 'undefined' && localStorage.getItem(COLLAPSE_KEY) === '1';
    });
    const [paletteOpen, setPaletteOpen] = useState(false);
    const [shortcutsOpen, setShortcutsOpen] = useState(false);
    useEffect(() => {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(COLLAPSE_KEY, collapsed ? '1' : '0');
        }
    }, [collapsed]);
    // Editor routes opt out of the shell entirely (they take the whole viewport).
    if (bare) {
        return _jsx(_Fragment, { children: children });
    }
    const mainCls = `app-main${darkNative ? ' dark-native' : ''}`;
    const handleOpenPalette = () => {
        if (onOpenPalette)
            onOpenPalette();
        if (commandPalette)
            setPaletteOpen(true);
    };
    // Only wire the sidebar search bar to open the palette when the consumer
    // actually has one to show (either via render-prop or by handling the open
    // callback themselves). Use conditional spread so we don't pass
    // `onOpenPalette: undefined` (rejected by exactOptionalPropertyTypes).
    const wantsPalette = onOpenPalette || commandPalette;
    const paletteOpenProps = wantsPalette ? { onOpenPalette: handleOpenPalette } : {};
    return (_jsxs("div", { className: "ip-shell", children: [_jsxs("div", { className: `app-shell ${collapsed ? 'is-collapsed' : ''}`, children: [_jsx(Sidebar, { navGroups: navGroups, collapsed: collapsed, onToggleCollapse: () => setCollapsed((c) => !c), ...paletteOpenProps, ...(sidebar?.counts !== undefined ? { counts: sidebar.counts } : {}), ...(sidebar?.isFeatureEnabled !== undefined
                            ? { isFeatureEnabled: sidebar.isFeatureEnabled }
                            : {}), ...(sidebar?.favorites !== undefined ? { favorites: sidebar.favorites } : {}), ...(sidebar?.recents !== undefined ? { recents: sidebar.recents } : {}), ...(sidebar?.wordmark !== undefined ? { wordmark: sidebar.wordmark } : {}), ...(sidebar?.footer !== undefined ? { footer: sidebar.footer } : {}), ...(brandMark !== undefined ? { brandMark } : {}) }), _jsx(Topbar, { crumbs: crumbs, ...(rightSlot !== undefined ? { rightSlot } : {}) }), _jsx("main", { className: mainCls, children: children })] }), commandPalette
                ? commandPalette({ open: paletteOpen, onClose: () => setPaletteOpen(false) })
                : null, shortcutsPanel
                ? shortcutsPanel({ open: shortcutsOpen, onClose: () => setShortcutsOpen(false) })
                : null] }));
}
//# sourceMappingURL=AppShell.js.map